import { inject } from '@angular/core';
import { Route, UrlSegment } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Role } from '../model/Role';

export const adminOrGroupUserLoadGuard = (
  route: Route,
  segments: UrlSegment[],
) => {
  const authService = inject(AuthenticationService);

  const currentUser = authService.getCurrentUser();
  if (
    currentUser &&
    (currentUser.userType === Role.GROUP ||
      currentUser.userType === Role.ADMINISTRATOR)
  ) {
    return true;
  } else {
    return false;
  }
};
